import React from 'react';

// Reusable SVG pictogram components for LunaMoon
// All icons accept className and size props

const defaultSize = 48;
const s = (props, d, viewBox = '0 0 24 24') => {
  const { size = defaultSize, className = '', ...rest } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox={viewBox}
      fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
      className={className} {...rest}>
      {d}
    </svg>
  );
};

export const MoonIcon = (props) => s(props, <>
  <path d="M21 12.79A9 9 0 1 1 11.21 3a7 7 0 0 0 9.79 9.79z" />
</>);

export const CrystalBallIcon = (props) => s(props, <>
  <circle cx="12" cy="10" r="7" />
  <path d="M8.5 20h7" />
  <path d="M10 17h4" />
  <path d="M9 7c1.5-1 3.5-1 5 0" strokeOpacity="0.5" />
</>);

export const ChatIcon = (props) => s(props, <>
  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
</>);

export const PhoneIcon = (props) => s(props, <>
  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
</>);

export const FreeIcon = (props) => s(props, <>
  <circle cx="12" cy="12" r="10" />
  <path d="M8 12h8" />
  <path d="M12 8v8" />
</>);

export const TarotIcon = (props) => s(props, <>
  <rect x="5" y="2" width="14" height="20" rx="2" />
  <path d="M12 7l1.5 3 3.5.5-2.5 2.5.5 3.5L12 15l-3 1.5.5-3.5L7 10.5l3.5-.5z" />
</>);

export const FortuneIcon = (props) => s(props, <>
  <circle cx="12" cy="12" r="10" />
  <path d="M12 2v20M2 12h20" strokeOpacity="0.3" />
  <path d="M12 6a2 2 0 1 1 0 4 2 2 0 0 1-2 2" />
  <circle cx="12" cy="16" r="0.5" fill="currentColor" />
</>);

export const PalmIcon = (props) => s(props, <>
  <path d="M18 11V6a2 2 0 0 0-4 0v1M14 7V4a2 2 0 0 0-4 0v4M10 5.5V4a2 2 0 0 0-4 0v7" />
  <path d="M18 11a2 2 0 0 1 4 0v2a8 8 0 0 1-8 8h-2a8 8 0 0 1-6-2.7" />
</>);

export const HeartIcon = (props) => s(props, <>
  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78z" />
</>);

export const BriefcaseIcon = (props) => s(props, <>
  <rect x="2" y="7" width="20" height="14" rx="2" />
  <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
</>);

export const HomeIcon = (props) => s(props, <>
  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
  <polyline points="9 22 9 12 15 12 15 22" />
</>);

export const CalendarIcon = (props) => s(props, <>
  <rect x="3" y="4" width="18" height="18" rx="2" />
  <line x1="16" y1="2" x2="16" y2="6" />
  <line x1="8" y1="2" x2="8" y2="6" />
  <line x1="3" y1="10" x2="21" y2="10" />
</>);

export const HashIcon = (props) => s(props, <>
  <line x1="4" y1="9" x2="20" y2="9" />
  <line x1="4" y1="15" x2="20" y2="15" />
  <line x1="10" y1="3" x2="8" y2="21" />
  <line x1="16" y1="3" x2="14" y2="21" />
</>);

export const StarIcon = (props) => s(props, <>
  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
</>);

export const ShieldIcon = (props) => s(props, <>
  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  <polyline points="9 12 11 14 15 10" />
</>);

export const UserIcon = (props) => s(props, <>
  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
  <circle cx="12" cy="7" r="4" />
</>);

export const UsersIcon = (props) => s(props, <>
  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
  <circle cx="9" cy="7" r="4" />
  <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
</>);

export const MailIcon = (props) => s(props, <>
  <rect x="2" y="4" width="20" height="16" rx="2" />
  <polyline points="22 7 12 13 2 7" />
</>);

export const SettingsIcon = (props) => s(props, <>
  <circle cx="12" cy="12" r="3" />
  <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
</>);

export const AlertIcon = (props) => s(props, <>
  <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
  <line x1="12" y1="9" x2="12" y2="13" />
  <line x1="12" y1="17" x2="12.01" y2="17" />
</>);

export const CheckCircleIcon = (props) => s(props, <>
  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
  <polyline points="22 4 12 14.01 9 11.01" />
</>);

export const XCircleIcon = (props) => s(props, <>
  <circle cx="12" cy="12" r="10" />
  <line x1="15" y1="9" x2="9" y2="15" />
  <line x1="9" y1="9" x2="15" y2="15" />
</>);

export const ServerIcon = (props) => s(props, <>
  <rect x="2" y="2" width="20" height="8" rx="2" />
  <rect x="2" y="14" width="20" height="8" rx="2" />
  <circle cx="6" cy="6" r="1" fill="currentColor" />
  <circle cx="6" cy="18" r="1" fill="currentColor" />
</>);

export const ChartIcon = (props) => s(props, <>
  <line x1="18" y1="20" x2="18" y2="10" />
  <line x1="12" y1="20" x2="12" y2="4" />
  <line x1="6" y1="20" x2="6" y2="14" />
</>);

// ─── Category Pictograms (military-clean geometric style) ───

// 신점 - divination bowl / oracle eye
export const CatShinjeomIcon = (props) => s(props, <>
  <circle cx="12" cy="12" r="3" />
  <circle cx="12" cy="12" r="1" fill="currentColor" stroke="none" />
  <path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z" />
</>);

// 사주 - four pillars / document scroll
export const CatSajuIcon = (props) => s(props, <>
  <rect x="5" y="3" width="14" height="18" rx="1" />
  <line x1="8" y1="7" x2="16" y2="7" />
  <line x1="8" y1="10" x2="16" y2="10" />
  <line x1="8" y1="13" x2="13" y2="13" />
  <line x1="12" y1="3" x2="12" y2="21" strokeOpacity="0.2" />
</>);

// 타로 - tarot card with star
export const CatTarotIcon = (props) => s(props, <>
  <rect x="5" y="2" width="14" height="20" rx="2" />
  <polygon points="12 7 13.5 10 17 10.5 14.5 13 15 16.5 12 15 9 16.5 9.5 13 7 10.5 10.5 10" />
</>);

// 주역 - I Ching trigram lines
export const CatJuyeokIcon = (props) => s(props, <>
  <line x1="5" y1="5" x2="19" y2="5" />
  <line x1="5" y1="8" x2="11" y2="8" /><line x1="13" y1="8" x2="19" y2="8" />
  <line x1="5" y1="11" x2="19" y2="11" />
  <line x1="5" y1="14" x2="11" y2="14" /><line x1="13" y1="14" x2="19" y2="14" />
  <line x1="5" y1="17" x2="19" y2="17" />
  <line x1="5" y1="20" x2="11" y2="20" /><line x1="13" y1="20" x2="19" y2="20" />
</>);

// 점성술 - astrology / star with orbit ring
export const CatAstrologyIcon = (props) => s(props, <>
  <circle cx="12" cy="12" r="9" />
  <circle cx="12" cy="12" r="3" />
  <line x1="12" y1="3" x2="12" y2="6" />
  <line x1="12" y1="18" x2="12" y2="21" />
  <line x1="3" y1="12" x2="6" y2="12" />
  <line x1="18" y1="12" x2="21" y2="12" />
</>);

// 자미두수 - constellation / stars grid
export const CatJamidusuIcon = (props) => s(props, <>
  <circle cx="6" cy="6" r="1.5" />
  <circle cx="18" cy="6" r="1.5" />
  <circle cx="12" cy="12" r="1.5" />
  <circle cx="6" cy="18" r="1.5" />
  <circle cx="18" cy="18" r="1.5" />
  <line x1="6" y1="6" x2="12" y2="12" strokeOpacity="0.3" />
  <line x1="18" y1="6" x2="12" y2="12" strokeOpacity="0.3" />
  <line x1="6" y1="18" x2="12" y2="12" strokeOpacity="0.3" />
  <line x1="18" y1="18" x2="12" y2="12" strokeOpacity="0.3" />
</>);

// 손금/관상 - palm with lines
export const CatPalmReadIcon = (props) => s(props, <>
  <path d="M18 11V6a2 2 0 0 0-4 0v1M14 7V4a2 2 0 0 0-4 0v4M10 5.5V4a2 2 0 0 0-4 0v7" />
  <path d="M18 11a2 2 0 0 1 4 0v2a8 8 0 0 1-8 8h-2a8 8 0 0 1-6-2.7" />
  <path d="M8 14c2-1 4 0 6-1" strokeOpacity="0.4" />
</>);

// 꿈해몽 - dream cloud
export const CatDreamIcon = (props) => s(props, <>
  <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
  <circle cx="10" cy="13" r="1" fill="currentColor" stroke="none" />
  <circle cx="14" cy="11" r="1" fill="currentColor" stroke="none" />
</>);

// 풍수 - feng shui compass / mountain + water
export const CatFengshuiIcon = (props) => s(props, <>
  <path d="M4 18l4-8 4 5 3-3 5 6" />
  <path d="M2 20h20" />
  <circle cx="17" cy="6" r="3" />
</>);

// 작명 - naming / pen writing character
export const CatNamingIcon = (props) => s(props, <>
  <path d="M17 3a2.83 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5z" />
  <line x1="15" y1="5" x2="19" y2="9" />
</>);

// 궁합 - compatibility / two hearts connected
export const CatCompatIcon = (props) => s(props, <>
  <path d="M14.5 4.5a4 4 0 0 0-5.66 0L8 5.36 7.16 4.5a4 4 0 0 0-5.66 5.66L8 16.67l6.5-6.51a4 4 0 0 0 0-5.66z" />
  <path d="M22.5 8.5a4 4 0 0 0-5.66 0L16 9.36l-.84-.86a4 4 0 0 0-5.66 5.66L16 20.67l6.5-6.51a4 4 0 0 0 0-5.66z" />
</>);

// 수비학 - numerology / hash with numbers
export const CatNumerologyIcon = (props) => s(props, <>
  <line x1="4" y1="9" x2="20" y2="9" />
  <line x1="4" y1="15" x2="20" y2="15" />
  <line x1="10" y1="3" x2="8" y2="21" />
  <line x1="16" y1="3" x2="14" y2="21" />
  <circle cx="7" cy="6" r="1" fill="currentColor" stroke="none" />
  <circle cx="17" cy="12" r="1" fill="currentColor" stroke="none" />
  <circle cx="7" cy="18" r="1" fill="currentColor" stroke="none" />
</>);
